import { toast } from "react-toastify";
export const ValidateResponse = (arg) => {
    const result = arg?.data?.result ?? arg?.data;

    if (result?.status) {
        return result?.data ? result.data : []
    } else {
        toast.error(result?.message)
        return []
    }
}
export const AddEditResponse = (arg) => {
    const result = arg?.data?.result ?? arg?.data;

    if (result?.status) {
        toast.success(result?.message)
        return result?.data ? result.data : []
    } else {
        toast.error(result?.message)
        return []
    }
}
